<div class="container">
  <div class="text-center">
    <h5 class="display-5 mt-3 mb-4">Modify Services</h5>
  </div>
</div>

<div class="container">
  <button type="button" class="btn btn-success addNewService-btn" data-toggle="modal" data-target="#addNewSubjectModal">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-plus pb-1" viewBox="0 0 16 16">
      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
    </svg>
    Add New Service
  </button>
  <hr>
</div>

<!-- Add New Subject Modal -->
<div class="modal fade" id="addNewSubjectModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Add New Service</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <label>Heading:</label>
        <div class="input-group input-group-lg mb-3">
          <input type="text" class="form-control" [(ngModel)]="serviceHeading">
        </div>

        <label>Details:</label>
        <div class="input-group mb-3">
          <textarea class="form-control form-control-lg" rows="4" [(ngModel)]="serviceDetails"></textarea>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onAdd()">Add</button>
      </div>
    </div>
  </div>
</div>

<div class="my-5" *ngIf="isServicesLoading == true" style="width: 100%; display: flex; align-items: center; justify-content: center;">
  <div class="loader"></div>
  <div>
    Loading Services...
  </div>
</div>

<div class="container" *ngIf="isServicesLoading == false">
  <h4 class="pb-3">My Services List</h4>
  <div class="row pb-5">
    <div class="col-md-3 pb-2" *ngFor="let service of serviceList">
      <div class="card text-center" style="border: 1px solid silver;">
        <div class="card-body">
          <h4 class="pb-3">{{ service.title }}</h4>
          <p>{{ service.description }}</p>
        </div>
        <div class="row text-center p-2">
          <div class="col">
            <button
              class="btn btn-sm btn-danger btn-block"
              data-toggle="modal"
              data-target="#deleteServiceModal"
              (click)="onDelete(service._id)">
              Delete
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-sm btn-info btn-block"
              data-toggle="modal"
              data-target="#updateServiceModal"
              (click)="onUpdate(service)">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Update Service Modal -->
<div class="modal fade" id="updateServiceModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Update Service</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <label>Heading:</label>
        <div class="input-group input-group-lg mb-3">
          <input type="text" class="form-control" [(ngModel)]="selectedServiceTitle">
        </div>

        <label>Details:</label>
        <div class="input-group mb-3">
          <textarea class="form-control form-control-lg" rows="4" [(ngModel)]="selectedServiceDetail"></textarea>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onUpdateConfirm()">Update</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Subject Modal -->
<div class="modal fade" id="deleteServiceModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Are you sure?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Do you really want to delete this service?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-outline-dark" data-dismiss="modal" (click)="onDeleteConfirm()">Confirm</button>
        <button type="button" class="btn btn-sm btn-outline-danger" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
